<!--
  Deleting a deal (E4 RF-51, amended 2026-10-08). With open activities the user chooses what
  becomes of them — nothing is preselected and the deletion waits for the choice. MatDialog
  provides the shell; everything inside is Hyper markup.
-->
<div class="modal-header">
  <h4 class="modal-title" id="deleteDealTitle">
    <i class="ri-delete-bin-line me-1"></i>
    {{ 'kanban.deleteDeal.title' | translate }}
  </h4>
  <button type="button" class="btn-close" [attr.aria-label]="'shared.confirmation.cancelButton' | translate" (click)="close()"></button>
</div>

<div class="modal-body">
  <p class="mb-3">{{ 'kanban.deleteDeal.confirmPlain' | translate: { deal: $safeNavigationMigration(data?.card?.name) } }}</p>

  @if (loadingActivities) {
    <div class="d-flex align-items-center gap-2 text-muted" role="status">
      <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
      {{ 'task.conclude.loading' | translate }}
    </div>
  } @else if (asksAboutActivities) {
    @if (loadFailed) {
      <div class="alert alert-warning py-2 mb-3" role="alert">
        <p class="mb-0"><i class="ri-error-warning-line me-1"></i>{{ 'kanban.deleteDeal.loadError' | translate }}</p>
      </div>
    } @else {
      <p class="fw-semibold mb-2">
        <i class="ri-task-line me-1"></i>{{ 'kanban.deleteDeal.openActivities' | translate: { count: openActivities.length } }}
      </p>
      <ul class="list-unstyled border rounded p-2 mb-3">
        @for (task of shownActivities; track task._id) {
          <li class="d-flex flex-column py-1">
            <span class="fw-bold text-truncate">{{ title(task) }}</span>
            <small class="text-muted">
              {{ typeLabel(task) | translate }}
              ·
              @if (task.deadlineAt) {
                {{ task.deadlineAt | timezoneDate : momentFormat(task) : getTimezoneCompanyCurrentUser() }}
                @if (task.untimed) {
                  ({{ 'task.activity.untimed' | translate }})
                }
              } @else {
                {{ 'task.activity.noDate' | translate }}
              }
              @if (task.user?.name) {
                · <i class="ri-user-line"></i> {{ task.user?.name }}
              }
            </small>
          </li>
        }
        @if (hiddenCount > 0) {
          <li class="text-muted font-13 pt-1">{{ 'kanban.deleteDeal.more' | translate: { count: hiddenCount } }}</li>
        }
      </ul>
    }

    <p class="fw-semibold mb-2" id="deleteDealQuestion">{{ 'kanban.deleteDeal.question' | translate }}</p>
    <div role="radiogroup" aria-labelledby="deleteDealQuestion">
      <div class="form-check mb-2">
        <input
          class="form-check-input"
          type="radio"
          name="deleteDealActivities"
          id="deleteDealConclude"
          [checked]="action === 'CONCLUDE'"
          [disabled]="submitting"
          (change)="choose('CONCLUDE')"
        />
        <label class="form-check-label" for="deleteDealConclude">
          <span class="fw-semibold">{{ 'kanban.deleteDeal.conclude' | translate }}</span>
          <small class="text-muted d-block">{{ 'kanban.deleteDeal.concludeHint' | translate }}</small>
        </label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          name="deleteDealActivities"
          id="deleteDealDelete"
          [checked]="action === 'DELETE'"
          [disabled]="submitting"
          (change)="choose('DELETE')"
        />
        <label class="form-check-label" for="deleteDealDelete">
          <span class="fw-semibold">{{ 'kanban.deleteDeal.delete' | translate }}</span>
          <small class="text-muted d-block">{{ 'kanban.deleteDeal.deleteHint' | translate }}</small>
        </label>
      </div>
    </div>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" [disabled]="submitting" (click)="close()">
    {{ 'shared.confirmation.cancelButton' | translate }}
  </button>
  <button type="button" class="btn btn-danger" [disabled]="!canConfirm" (click)="confirm()">
    @if (submitting) {
      <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
    } @else {
      <i class="ri-delete-bin-line me-1"></i>
    }
    {{ 'kanban.deleteDeal.confirm' | translate }}
  </button>
</div>
